import { Component, OnInit } from '@angular/core';
import { BilingModel } from 'src/app/_models/Company/biling.model';
import { MembershipPlanModel } from 'src/app/_models/Company/membership-plan-model';
import { ApiService } from 'src/app/_services/api.service';
import { CurrencyModel } from 'src/app/_models/Company/currency.model';
import { DialogService } from 'primeng/dynamicdialog';
import { CheckoutComponent } from './checkout/checkout/checkout.component';
import { TranslateService } from '@ngx-translate/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { PagingModel } from 'src/app/_models/Common/paging-model';
import { CompanyModel } from 'src/app/_models/Company/CompanyModel';
import { CompanyService } from 'src/app/company.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-payment-and-bills',
  templateUrl: './payment-and-bills.component.html',
  styleUrls: ['./payment-and-bills.component.scss']
})
export class PaymentAndBillsComponent implements OnInit {

  public company: CompanyModel;
  companySubscription: Subscription;
  usersubscription: Subscription;

  public spinner: boolean = false;
  public membershipPlanList: Array<MembershipPlanModel>;
  public currencyInfo: CurrencyModel;
  public totalPages: number;
  public totalRecords: number;
  public pageNumber: number = 1;

  public bilingsList: Array<BilingModel>;
  public pagingModel: PagingModel;
  public totalRecordsBill: number;
  public totalPagesBill: number;
  public count: number = 0;
  public lastPageBill: number;

  public NoRecordsFound: string;

  constructor(
    public apiService: ApiService,
    private authService: AuthService,
    public dialogService: DialogService,
    public translate: TranslateService,
    public messageService: MessageService,
    private companyService: CompanyService,
  ) {
    this.membershipPlanList = new Array<MembershipPlanModel>();

    this.pagingModel = new PagingModel();
    this.bilingsList = new Array<BilingModel>();
  }

  ngOnInit(): void {
    this.getCompanyDetails();
    this.getmembershipplans(this.pageNumber);
    this.getPaymentsForCompany();
  }

  checkoutDialog(membershipPlan: MembershipPlanModel, currencyInfo: CurrencyModel) {
    const ref = this.dialogService.open(CheckoutComponent, {
      data: {
        membershipPlan: membershipPlan,
        currencyInfo: currencyInfo,
        allowedPaymentProcessors: this.company.allowedProcessors
      },
      autoZIndex: false,
      header: this.translate.instant('PAYMENT.PAYMENT_OPTIONS') + " - " + membershipPlan.name,
      width: 'auto'
    });
    ref.onClose.subscribe((success: boolean) => {
      if (success) {
        this.apiService.getCompanyDetails().subscribe((result)=>{
          this.getPaymentsForCompany();
          this.company.isMembershipPaid = true;
          this.messageService.add({ severity: 'success', summary: "Successfully purchased package: " + membershipPlan.name, life: 5000 });
        },(error)=>{
          this.messageService.add({ severity: 'warn', summary: "Error", life: 5000 });
        });
      }
    });
  }

  loadMoreMembershipPlans() {
    this.pageNumber = this.pageNumber + 1;
    this.getmembershipplans(this.pageNumber);
  }

  getmembershipplans(pageNumber: number) {
    this.spinner = true;
    this.apiService.getallmembershipplansforcompany(pageNumber).subscribe((response) => {
      this.totalPages = response.totalPages;
      this.totalRecords = response.totalRecords;
      this.currencyInfo = response.extendedData;
      if (response.pageNumber > 1) {
        this.membershipPlanList = this.membershipPlanList.concat(response.data)
      }
      else {
        this.membershipPlanList = response.data;
      }
      this.spinner = false;
    });
  };

  getCompanyDetails() {
    this.spinner = true;
    this.companySubscription = this.companyService.companyChanged
    .subscribe((company: CompanyModel) => {
      this.company = company;
      this.spinner = false;
    });
    this.company = this.companyService.getCompany();
    this.spinner = false;
  }
  
  starTrialPeriod() {
    this.spinner = true;
    this.apiService.startusingtrialperiod().subscribe((results) => {
      this.company.isUsingTrial = true;
      this.spinner = false;
    }, (error => {
      this.spinner = false;
      this.messageService.add({ severity: 'warn', summary: "Error", life: 5000 });
    }));
  }

  unsubscribe(){
    this.spinner=true;
    this.apiService.unsubscribecompany().subscribe(result=>{
      this.spinner=false;
      this.company.isSubscribed=false;
      this.messageService.add({ severity: 'success', summary: this.translate.instant('PAYMENT.SUBSCRIPTION_CANCELED'), life: 5000 });
    },
      (error => {
        this.spinner=false;
        this.messageService.add({ severity: 'warn', summary: "Error", life: 5000 });
    }));
  }

  getPaymentsForCompany() {
    this.apiService.getpaymentsforcompany(this.pagingModel).subscribe((result) => {
      this.bilingsList = result.data;
      this.totalRecordsBill = result.totalRecords;
      this.totalPagesBill = result.totalPages;
      this.lastPageBill = (this.totalPagesBill - 1) * this.pagingModel.pageSize;
    });
  }


  loadBills(event: LazyLoadEvent) {
    //next
    //@ts-ignore
    if (event.first > this.count) {
      this.pagingModel.pageNumber = this.pagingModel.pageNumber + 1;
      this.count = this.count + this.pagingModel.pageSize;
    }
    //previous
    //@ts-ignore
    if (event.first < this.count) {
      this.pagingModel.pageNumber = this.pagingModel.pageNumber - 1;
      this.count = this.count - this.pagingModel.pageSize;
    }
    //first
    //@ts-ignore
    if (event.first == 0) {
      this.pagingModel.pageNumber = 1;
      this.count = 0;
    }
    //last
    //@ts-ignore
    if (event.first == this.lastPageBill) {
      this.pagingModel.pageNumber = this.totalPagesBill;
      this.count = this.lastPageBill;
    }

    //random page number
    if (event.first != this.count) {
      // @ts-ignore
      this.pagingModel.pageNumber = (event.first / event.rows) + 1
      // @ts-ignore
      this.count = event.first;
    }

    this.apiService.getpaymentsforcompany(this.pagingModel).subscribe((result) => {
      this.bilingsList = result.data;
    });
  }
}
